import { render } from "./WindowShadowRender.vue?vue&type=template&id=8d424f00&scoped=true"
import script from "./WindowShadowRender.vue?vue&type=script&lang=js"
export * from "./WindowShadowRender.vue?vue&type=script&lang=js"

import "./WindowShadowRender.vue?vue&type=style&index=0&id=8d424f00&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d424f00"]])

export default __exports__